"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwitchPlanResponse = exports.SwitchPlanRequest = void 0;
var interfaces_1 = require("../../interfaces");
/** Запрос на данные для оформления смены тарифного плана */
var SwitchPlanRequest = /** @class */function () {
  function SwitchPlanRequest(values) {
    if (!values) {
      return;
    }
    this.plan_id = values.plan_id;
  }
  return SwitchPlanRequest;
}();
exports.SwitchPlanRequest = SwitchPlanRequest;
/** Ответ на запрос о данных для оформления подписки на платный тариф */
var SwitchPlanResponse = /** @class */function (_super) {
  __extends(SwitchPlanResponse, _super);
  function SwitchPlanResponse(values) {
    var _this = _super.call(this, values) || this;
    /** Необходимо выполнить оплату */
    _this.payment_required = false;
    _this.payment_required = values.payment_required;
    return _this;
  }
  return SwitchPlanResponse;
}(interfaces_1.CommonProcessingResponse);
exports.SwitchPlanResponse = SwitchPlanResponse;
